module.exports = __webpack_public_path__ + "media/durango/durango-d91bb27b.jpg";